<template>
  <div class="page--register-detail new-form">
    <div>
      <div class="container maincontent">
        <ProgressBar class="progress--register" :progress-bar-width="progressBar" />

        <section id="sign-in-steps" class="content">
          <div class="head-content">
            <p class="text-heading">Lengkapi Profil Kamu</p>
          </div>
          <form method="post" :class="{ submitting: showLoader }" @submit.prevent="validateBeforeSubmit">
            <div id="upload" class="field upload">
              <div class="uploadarea">
                <a href="" class="upload-wrapper" @click.prevent="triggerUpload">
                  <span class="photo-area">
                    <img :src="registerData.imageData || '/assets/img/avatar-soco.png'" />
                  </span>
                  <span class="photo-icon"></span>
                  <span class="photo-status">Ganti Foto</span>
                </a>
                <input
                  id="foto"
                  ref="foto"
                  type="file"
                  name="foto"
                  accept="image/*"
                  class="hidden"
                  @change="previewFoto"
                />
                <div class="fieldarea">
                  <p v-show="errors.has('foto')" class="alert">
                    {{ errors.first('foto') }}
                  </p>
                </div>
              </div>
            </div>

            <div id="inputWrapper" class="input-wrapper">
              <div class="field" :class="{ 'has-error': errors.has('biodata') }">
                <label class="text-label" for="biodata">Biodata</label>
                <div class="fieldarea new-text">
                  <textarea
                    id="biodata"
                    v-model="registerData.biodata"
                    class="text textarea"
                    name="biodata"
                    maxlength="160"
                    placeholder="Inilah kesempatan untuk menceritakan tentang diri kamu"
                    @keyup="countdown"
                  >
                  </textarea>
                  <p class="counter" :class="{ alert: hasCountError }">
                    <span class="count">{{ currentCount }}/160</span>
                  </p>
                  <p v-show="errors.has('biodata')" class="alert">
                    {{ errors.first('biodata') }}
                  </p>
                </div>
              </div>

              <div class="field" :class="{ 'has-error': errors.has('tanggal') }">
                <label class="text-label" for="tanggal"
                  >Tanggal Lahir <span class="required">*</span
                  ><img v-tooltip="tooltipOptions" src="/assets/img/tooltip.png" class="birthday-tooltip"
                /></label>
                <input
                  v-model="registerData.tanggal"
                  v-validate="'required'"
                  type="text"
                  class="hidden"
                  name="tanggal"
                />
                <div id="tanggal" class="fieldarea new-text">
                  <datepicker
                    v-model="registerData.tanggal"
                    placeholder="DD / MM / YYYY"
                    :open-date="minAge.fullDate"
                    :disabled-dates="{
                      from: new Date(minAge.year, minAge.month, minAge.date),
                    }"
                    @selected="convertDate"
                  >
                  </datepicker>
                  <p v-show="errors.has('tanggal')" class="alert">
                    {{ errors.first('tanggal') }}
                  </p>
                </div>
              </div>

              <div class="field" :class="{ 'has-error': errors.has('country') }">
                <label class="text-label" for="country">Negara <span class="required">*</span></label>
                <div class="fieldarea fieldselect new-text">
                  <select
                    id="country"
                    v-model="registerData.country_id"
                    v-validate="'required'"
                    name="country"
                    :disabled="true"
                    @change="loadProvince"
                  >
                    <option value="999" selected>Indonesia</option>
                  </select>
                  <p v-show="errors.has('country')" class="alert">
                    {{ errors.first('country') }}
                  </p>
                </div>
              </div>

              <div class="field">
                <div class="fieldarea">
                  <div class="field" :class="{ 'has-error': errors.has('province') }">
                    <label class="text-label" for="province">Provinsi <span class="required">*</span></label>
                    <div class="fieldarea fieldselect new-text">
                      <select
                        id="province"
                        v-model="registerData.province_id"
                        v-validate="'required'"
                        name="province"
                        @change="loadCity"
                      >
                        <option v-if="!registerData.selectCountry" value="" selected disabled>
                          Pilih negara terlebih dahulu
                        </option>
                        <option v-else value="" selected disabled>Pilih provinsi</option>
                        <option v-for="provinsi in registerData.province" :key="provinsi._id" :value="provinsi._id">
                          {{ provinsi.name }}
                        </option>
                      </select>
                      <p v-show="errors.has('province')" class="alert">
                        {{ errors.first('province') }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="fieldarea">
                  <div class="field" :class="{ 'has-error': errors.has('city') }">
                    <label class="text-label" for="city">Kota / Kabupaten<span class="required">*</span></label>
                    <div class="fieldarea fieldselect new-text">
                      <select
                        id="city"
                        v-model="registerData.city_id"
                        v-validate="'required'"
                        name="city"
                        :disabled="registerData.selectProvince ? false : true"
                      >
                        <option v-if="!registerData.selectProvince" value="" selected disabled>
                          Pilih provinsi terlebih dahulu
                        </option>
                        <option v-else value="" selected disabled>Pilih kota / kabupaten</option>
                        <option v-for="kota in registerData.city" :key="kota._id" :value="kota._id">
                          {{ kota.type }} {{ kota.name }}
                        </option>
                      </select>
                      <p v-show="errors.has('city')" class="alert">
                        {{ errors.first('city') }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="field" :class="{'has-error': errors.has('kecamatan') }">
                <label class="text-label" for="kecamatan">Kecamatan <span class="required">*</span></label>
                <div class="fieldarea fieldselect">
                  <select name="kecamatan" id="kecamatan" :disabled="registerData.selectCity ? false : true"
                    v-model="registerData.district_id"
                    v-validate="'required'">
                    <option value="" selected disabled v-if="!registerData.selectCity">Pilih kota terlebih dahulu</option>
                    <option value="" selected disabled v-else>Pilih kecamatan</option>
                    <option v-for="kecamatan in registerData.district" :value="kecamatan._id" :key="kecamatan._id">
                      {{ kecamatan.name }}
                    </option>
                  </select>
                  <p v-show="errors.has('kecamatan')" class="alert">{{ errors.first('kecamatan') }}</p>
                </div>
              </div> -->
              <div class="field fieldsub fieldarea--social-media">
                <div class="title">
                  <div class="wrapper">
                    <span :class="[{ collapsed: isSocialMediaCollapsed }, 'label']" @click.prevent="collapseSocialMedia"
                      >Your Social Media</span
                    >
                  </div>
                </div>
              </div>
              <!-- <div class="field">
                <div class="fieldarea fieldselect fieldarea--social-media">
                  <select
                    name="socialmedia"
                    id="socialmedia"
                    v-model="socialMedia"
                  >
                    <option selected value="">YOUR SOCIAL MEDIA</option>
                    <option v-for="(media, key) in listSocialMedia" :value="media.name" :key="key">
                      {{ media.name }}
                    </option>
                  </select>
                </div>
              </div> -->
              <div :class="[{ collapsed: isSocialMediaCollapsed }, 'social-media']">
                <div class="field">
                  <label class="text-label" for="it">Instagram</label>
                  <div class="fieldarea field-group new-text">
                    <div class="prefix w-25">@</div>
                    <input
                      id="it"
                      v-model="registerData.social_url.instagram"
                      type="text"
                      name="it"
                      class="text"
                      value=""
                      placeholder="username"
                      autocomplete="off"
                    />
                  </div>
                </div>

                <div class="field">
                  <label class="text-label" for="tw">Twitter</label>
                  <div class="fieldarea field-group new-text">
                    <div class="prefix w-25">@</div>
                    <input
                      id="tw"
                      v-model="registerData.social_url.twitter"
                      type="text"
                      name="tw"
                      class="text"
                      value=""
                      placeholder="username"
                      autocomplete="off"
                    />
                  </div>
                </div>

                <div class="field" :class="{ 'has-error': errors.has('fb') }">
                  <label class="text-label" for="fb">Facebook</label>
                  <div class="fieldarea new-text">
                    <input
                      id="fb"
                      v-model="registerData.social_url.facebook"
                      v-validate="'url'"
                      type="text"
                      name="fb"
                      class="text"
                      value=""
                      placeholder="facebook.com/username"
                      autocomplete="off"
                    />
                    <p v-show="errors.has('fb')" class="alert">
                      {{ errors.first('fb') }}
                    </p>
                  </div>
                </div>

                <div class="field" :class="{ 'has-error': errors.has('yt') }">
                  <label class="text-label" for="yt">YouTube Channel</label>
                  <div class="fieldarea new-text">
                    <input
                      id="yt"
                      v-model="registerData.social_url.youtube"
                      v-validate="'url'"
                      type="text"
                      name="yt"
                      class="text"
                      value=""
                      placeholder="Youtube channel url"
                      autocomplete="off"
                    />
                    <p v-show="errors.has('yt')" class="alert">
                      {{ errors.first('yt') }}
                    </p>
                  </div>
                </div>

                <div class="field" :class="{ 'has-error': errors.has('bl') }">
                  <label class="text-label" for="bl">Blog</label>
                  <div class="fieldarea new-text">
                    <input
                      id="bl"
                      v-model="registerData.social_url.blog"
                      v-validate="'url'"
                      type="text"
                      name="bl"
                      class="text"
                      value=""
                      placeholder="Blog url"
                      autocomplete="off"
                    />
                    <p v-show="errors.has('bl')" class="alert">
                      {{ errors.first('bl') }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="formaction">
                <input
                  v-if="showLoader == false"
                  type="submit"
                  value="Next"
                  :class="{
                    disabled: !isFormAlreadyFilled,
                  }"
                  class="red btn"
                />
                <GLoaderSpin v-else />
              </div>

              <div class="overlaysubmit"></div>
            </div>
          </form>
        </section>
      </div>
    </div>

    <GModal v-if="showModal" class="custom-modal modal-mask modal--upload-picture">
      <template #header>
        <h4 class="modal__heading">Pilih Foto Kamu</h4>
        <span class="link modal-dismiss" @click="closeUploadPhoto">&times;</span>
      </template>
      <template slot="body">
        <div class="croppa-wrapper">
          <croppa
            v-model="croppa"
            :height="300"
            :width="300"
            :prevent-white-space="false"
            initial-size="contain"
            :file-size-limit="5242880"
            :accept="'image/*'"
            @file-size-exceed="onFileSizeExceed"
            @file-choose="(isFileChoose = true), (fileSizeExceed = false)"
            @image-remove="(isFileChoose = false), (fileSizeExceed = false)"
          >
          </croppa>
        </div>
        <div v-if="fileSizeExceed" class="field">
          <div class="fieldarea">
            <p class="alert">Ukuran maksimum 5MB</p>
          </div>
        </div>
        <!-- <a href="#" class="close button button-trans"
            @click.prevent="showModal = false">
            CLOSE
            </a> -->
        <div class="croppa-footer">
          <a
            v-show="isFileChoose"
            href="#"
            class="close btn button-trans modal-upload-foto-save"
            @click.prevent="saveCrop"
            >Apply
          </a>
          <div v-show="isFileChoose" class="field fieldinfo">
            <div class="fieldarea">
              <p><i class="icon_lightbulb"></i> Atur foto kamu dengan scroll</p>
            </div>
          </div>
        </div>
      </template>
    </GModal>
  </div>
</template>

<script>
import Auth from '@/shared/auth';
import Datepicker from 'vuejs-datepicker';
import Croppa from 'vue-croppa';
import Q from 'q';
import VTooltip from 'v-tooltip';

const Config = require('~/config/default.env').default;

Vue.use(VTooltip);
Vue.use(Croppa);

export default {
  name: 'register-detail',
  components: {
    Datepicker,
  },
  data() {
    return {
      registerData: {
        imageData: '/assets/img/avatar-soco.png',
        image_base64: '',
        image: '',
        _token: '',
        username: '',
        name: '',
        nickname: '',
        email: '',
        password: '',
        password_confirmation: '',
        salute_id: '1',
        firstname: '',
        lastname: '',
        biodata: '',
        tanggal: '',
        birthday_date: '',
        birthday_month: '',
        birthday_year: '',
        phone: '',
        country_id: 999,
        selectCountry: true,
        province: [],
        province_id: '',
        selectProvince: false,
        city: [],
        city_id: '',
        district: [],
        district_id: '',
        is_guest: 0,
        client_id: 0,
        social_url: {
          facebook: '',
          twitter: '',
          instagram: '',
          youtube: '',
          blog: '',
        },
        fb: '',
        it: '',
        yt: '',
        tw: '',
        bl: '',
      },
      maxCount: 160,
      remainingCount: 160,
      currentCount: 0,
      hasCountError: false,
      showLoader: false,
      showModal: false,
      croppa: {},
      isFileChoose: false,
      fileSizeExceed: false,
      isInputUsernameFocus: false,
      minAge: {
        year: '',
        month: '',
        date: '',
        fullDate: '',
      },
      socialMedia: '',
      listSocialMedia: [
        {
          name: 'Instagram',
        },
        {
          name: 'Twitter',
        },
        {
          name: 'Facebook',
        },
        {
          name: 'YouTube Channel',
        },
        {
          name: 'Blog',
        },
      ],
      isSocialMediaCollapsed: false,
      progressBar: (1 / 4) * 100 + '%',
    };
  },
  computed: {
    screen() {
      return this.$store.state.screen;
    },
    tooltipOptions() {
      const triggerValue = this.screen.isDesktop ? 'hover' : 'click';
      const placementValue = this.screen.isDesktop ? 'right-start' : 'auto';
      return {
        content: 'Dapatkan voucher sociolla spesial di setiap hari ulang tahun kamu',
        trigger: triggerValue,
        placement: placementValue,
        classes: 'tooltip-style-default',
      };
    },
    isFormAlreadyFilled() {
      return (
        this.registerData.tanggal &&
        (this.registerData.phone_no || this.registerData.email) &&
        this.registerData.country_id &&
        this.registerData.province_id &&
        this.registerData.city_id
      );
    },
    isModalShowVerifyCode() {
      return this.$store.state.modal.isModalShow.verifyCode;
    },
  },
  created() {
    this.loadDetails();
    this.loadProvince();
    this.minimumAge();
    this.registerData.username = this.$store.state.userProfile.user_name;
    this.registerData.nickname = this.$store.state.userProfile.user_name;
    this.registerData.firstname = this.$store.state.firstname;
    this.registerData.lastname = this.$store.state.lastname;
    this.registerData.email = this.$store.state.useremail;
    this.registerData.password = this.$store.state.userpassword;
    this.registerData.password_confirmation = this.$store.state.userpassword;
  },
  mounted() {
    const parent = document.querySelector('#app');
    parent.classList.remove('noscroll');
  },
  methods: {
    onBlurInInputUsername() {
      this.isInputUsernameFocus = false;
    },
    onFocusInInputUsername() {
      this.isInputUsernameFocus = true;
    },
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.showLoader = true;
          Auth.registerDetail(this).then(() => {
            if (this.registerData.image_base64) {
              this.$store.commit('userImage', this.registerData.image_base64);
            }
            Auth.me().then(() => {});
          });
          return;
        }
        if (document.getElementById(this.$validator.errors.items[0].field)) {
          document.getElementById(this.$validator.errors.items[0].field).scrollIntoView();
          window.scrollBy(0, -85);
        }
        return false;
      });
    },
    countdown() {
      if (this.remainingCount > -1) {
        this.remainingCount = 160 - this.registerData.biodata.length;
        this.currentCount = this.registerData.biodata.length;
        this.hasCountError = this.remainingCount < 0;
        return;
      }

      return false;
    },
    triggerUpload() {
      //this.$refs.foto.click()
      this.fileSizeExceed = false;
      this.showModal = true;
    },
    previewFoto(e) {
      const input = e.target;
      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.registerData.imageData = e.target.result;
          this.registerData.image_base64 = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    loadProvince() {
      this.registerData.city = [];
      this.registerData.city_id = '';
      this.registerData.district = [];
      this.registerData.district_id = '';

      axios
        .get(Config.MS_SOCO_PUBLIC_API_URL + '/provinces', {
          params: { sort: 'name' },
        })
        .then((response) => {
          this.registerData.province = response.data.data;
          this.registerData.selectCountry = true;
        })
        .catch((error) => {});
    },
    loadDetails() {
      const userProfile = this.$store.state.userProfile;
      if (this.$store.state.loggedin && userProfile && userProfile.beauty && Boolean(userProfile.beauty.length)) {
        this.$router.push('/');
      }
      if (userProfile && userProfile.gender && userProfile.gender.toLowerCase() === 'female') {
        this.progressBar = (1 / 6) * 100 + '%';
      }
      axios
        .get(Config.MS_ACCOUNTS_API_URL + '/user/me')
        .then((response) => {
          const statusFail = response.data.success === false;

          if (statusFail) {
            // this.$router.push('/')
          } else {
            // if (response.data.data.user_name && !response.data.data.phone_no) {
            this.registerData.email = response.data.data.email;
            this.registerData.username = response.data.data.user_name;
            this.registerData.firstname = response.data.data.first_name;
            this.registerData.lastname = response.data.data.last_name;
            this.registerData.image =
              'image' in response.data.data && response.data.data.image ? response.data.data.image : ''; // use same image from ms-accounts
            this.registerData.imageData =
              'image' in response.data.data && response.data.data.image ? response.data.data.image : ''; // show avatar first time loading
            this.registerData.salute_id = (response.data.data.salute || '').toLowerCase() == 'mr' ? 3 : 1;
            this.registerData.phone_no = 'phone_no' in response.data.data ? response.data.data.phone_no : '';

            // }else{
            // this.$router.push('/')
            // }
          }
        })
        .catch((error) => {});
    },
    loadCity() {
      this.registerData.selectProvince = false;
      this.registerData.city = [];
      this.registerData.city_id = '';
      this.registerData.selectCity = false;
      this.registerData.district = [];
      this.registerData.district_id = '';
      if (this.registerData.province_id) {
        axios
          .get(Config.MS_SOCO_PUBLIC_API_URL + '/cities?province_id=' + this.registerData.province_id + '&sort=name')
          .then((response) => {
            this.registerData.city = response.data.data;
            this.registerData.selectProvince = true;
          })
          .catch((error) => {});
      } else {
        console.error('ProvinceId should not empty!');
      }
    },
    loadDistrict() {
      this.registerData.selectCity = false;
      this.registerData.district = [];
      this.registerData.district_id = '';

      axios
        .get(Config.MS_SOCO_PUBLIC_API_URL + '/districts?city_id=' + this.registerData.city_id)
        .then((response) => {
          this.registerData.district = response.data.data;
          this.registerData.selectCity = true;
        })
        .catch((error) => {});
    },
    isNumeric(evt) {
      if (isNaN(evt.key)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    saveCrop() {
      this.registerData.imageData = this.croppa.generateDataUrl();
      this.registerData.image_base64 = this.croppa.generateDataUrl();
      this.closeUploadPhoto();
      this.isFileChoose = false;
      let fileName = '';
      if (!this.registerData.image) {
        fileName = `${this.registerData.username}-${Date.now()}.jpg`;
      } else {
        fileName = this.registerData.image.substring(this.registerData.image.lastIndexOf('/') + 1);
      }
      const cropFile = this.dataURLtoFile(this.croppa.generateDataUrl('image/jpeg'), fileName);
      return Q.try(() => {
        return axios.get(Config.MS_SOCO_PUBLIC_API_URL + '/pre-signed-url', {
          params: {
            fileName: fileName,
            contentType: cropFile.type,
          },
        });
      })
        .then((response) => {
          const temp_axios = axios;
          delete temp_axios.defaults.withCredentials;
          this.registerData.image = response.data.data.url;
          axios.put(response.data.data.signedUrl, cropFile, {
            headers: { 'Content-Type': cropFile.type },
          });
          axios.defaults.withCredentials = true;
          return null;
        })
        .catch((error) => {
          axios.defaults.withCredentials = true;
          if (this.$store.state.consoleLogMode) {
            console.log(error);
          }
        });
    },
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    onFileSizeExceed() {
      this.fileSizeExceed = true;
    },
    convertDate(data) {
      const d = new Date(data);
      this.registerData.birthday_date = d.getDate();
      this.registerData.birthday_month = d.getMonth() + 1;
      this.registerData.birthday_year = d.getFullYear();
    },
    minimumAge() {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 13);
      this.minAge.year = date.getFullYear();
      this.minAge.month = date.getMonth();
      this.minAge.date = date.getDate();
      this.minAge.fullDate = date;
    },
    collapseSocialMedia() {
      this.isSocialMediaCollapsed = !this.isSocialMediaCollapsed;
    },
    closeUploadPhoto() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss">
@import 'register-detail';
</style>
